
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Rectangle, LineStyle, LineKinds, PaintStyle, TextureKinds } from "../../../../domain/drawing";
import { UuidFactory } from "../../../../utilities";

@Component
export default class ShapeDrawableMixin extends Mixins() {
  @Prop()
  rectangle: Rectangle;

  @Prop()
  lineStyle: LineStyle;

  @Prop()
  paintStyle: PaintStyle;

  @Prop({ default: 4 })
  minStrokeWidth: number;

  @Emit()
  pointerdown(event: PointerEvent): void {}

  data() {
    return {
      uuid: UuidFactory.create(),
    };
  }
  uuid: string;

  get texture() {
    return {
      prefix: "TexturePattern_" + this.uuid + "_",
      color: this.paintStyle.color,
    };
  }

  get rectangleStyles() {
    return {
      position: "absolute",
      top: this.rectangle.x + "px",
      left: this.rectangle.y + "px",
      width: this.rectangle.width + "px",
      height: this.rectangle.height + "px",
    };
  }

  get shapeStyles() {
    return {
      fill: (this.paintStyle.kind === TextureKinds.None) ? "none" : "url(#" + this.texture.prefix + this.paintStyle.kind + ")",
      stroke: this.lineStyle.color.value,
      strokeWidth: this.lineStyle.width,
      strokeDasharray: (this.lineStyle.kind === LineKinds.Dotted) ? "3" : "0",
      pointerEvents: "visiblePainted",
    };
  }

  get draggableShapeStyles() {
    return {
      fill: "none",           // none.(transparentだと描画はされるため、pointerEvents対象になってしまう.)
      stroke: "transparent",  // transparentで描画する事で、pointerEvents対象とする.)
      strokeWidth: Math.max(this.shapeStyles.strokeWidth, this.minStrokeWidth),
      strokeDasharray: this.shapeStyles.strokeDasharray,
      pointerEvents: this.shapeStyles.pointerEvents,
    };
  }
}
